module.exports = "pegasus/assets/blocks/column-1-theme4.png";